import { approvalApi } from "../api/generated/wrappers/approval";
import { createQueryKeys } from "./create-query-keys";
const approvalQueryKeys = createQueryKeys("approval", {
    line: (documentType, documentId) => ({
        queryKey: ["line", documentType, documentId],
        queryFn: async () => await approvalApi.getApprovalLine(documentType, documentId),
    }),
    myPending: (documentType) => ({
        queryKey: ["myPending", documentType],
        queryFn: async () => await approvalApi.getMyPendingSteps(documentType),
    }),
});
export default approvalQueryKeys;
